import React from 'react'
import { Grid } from '@mui/material'

import { PersonCustomizationDialog } from '@/components/person-customization-dialog.tsx'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { useMutatePersonalSettings, useRequestAcqReport } from '@/services'
import { AutoReportDialog, ReportDialog } from '@/components'
import { useAppSelector } from '@/stores/hooks.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'

import { defaultSettings, KEY_PAGE, PartialAcqPayment } from './default-settings.tsx'

export const AqcActionButtons = (): React.ReactElement => {
  const settings = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE))

  const getSettings = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(defaultSettings)
    const settings: RowProps[] = settingsByRequest.map((e) => ({
      id: e,
      label: defaultSettings[e as keyof PartialAcqPayment],
      isChecked: true,
    }))
    Object.keys(defaultSettings).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({ id: key, label: defaultSettings[key as keyof PartialAcqPayment], isChecked: false })
      }
    })

    return settings
  }

  return (
    <Grid
      container
      spacing={2}
      justifyContent={{
        xs: 'flex-start',
        lg: 'flex-end',
      }}
    >
      <Grid item>
        <AutoReportDialog kind="ACQ" />
      </Grid>
      <Grid item>
        <ReportDialog mutation={useRequestAcqReport()} />
      </Grid>
      <Grid item>
        <PersonCustomizationDialog
          personalSettingsKey={KEY_PAGE}
          mutation={useMutatePersonalSettings()}
          itemsDesktop={getSettings('desktop', settings)}
          itemsMobile={getSettings('mobile', settings)}
        />
      </Grid>
    </Grid>
  )
}
